import React, { useState, useEffect } from "react";
import { Backdrop } from "@mui/material";
import "./EnhanceLoader.css";

const messages = [
    "Scanning your resume to unlock amazing opportunities...",
    "Harnessing the power of AI to find your perfect match",
    "Matching your skills to real roles that get you",
    "Opportunity is knocking... get ready!",
];


const SignUpLoader = () => {
    const [currentLine, setCurrentLine] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            // Loop the messages infinitely
            setCurrentLine((prev) => (prev + 1) % messages.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Backdrop
            sx={{
                backgroundColor: "#f6fcff",
                zIndex: (theme) => theme.zIndex.drawer + 1000,
            }}
            open={true}
        >
            <div className="loader-container">
                <div className="progress-line" style={{ marginBottom: "90px" }}>
                    <div className="progress-indicator animate-progress" />
                </div>
                <div className="message-box">
                    <p key={currentLine} className="message-line">
                        {messages[currentLine]}
                    </p>
                </div>
            </div>
        </Backdrop>
    );
};

export default SignUpLoader;
